module.exports = "pegasus_template/assets/blocks/column-14-theme6.png";